import { TenantPalette } from '../types';

/** §4A.1 — verified against `master`. */
export const iscPalette: TenantPalette = {
  primary: {
    light: '#F7EBF4',
    main: '#B03891',
    dark: '#97307C',
    contrastText: '#FFFFFF',
  },
  primaryLight: {
    light: '#FAF4F9',
    main: '#F7EBF4',
    dark: '#EDDEE9',
    contrastText: '#B03891',
  },
  secondary: {
    light: '#EAF0F9',
    main: '#2A6BBF',
  },
  pdfAccent: { main: '#2A6BBF' },
  pdfTint: { main: '#F7EBF4' },
  actionTint: { main: '#F7EBF4' },
  uiAccent: { main: '#2A6BBF' },
  textPrimary: { main: '#333333' },
  progressAccent: { main: '#2A6BBF' },
  progressTrack: { main: '#EFF2F4' },
  accordionIconOpen: { main: '#FFFFFF' },
};
